import { AppState } from "../rootReducer";

export const isLoggedIn = (state: AppState) => state.login.successful;

export const getLoginEmail = (state: AppState) => state.login.email || "";

export const getLoginPassword = (state: AppState) => state.login.password || "";

export const getLoginError = (state: AppState) => state.login.error || "";

export const getLoginRequesting = (state: AppState) =>
  state.login.requesting || false;

export const getLoginPasswordResetError = (state: AppState) =>
  state.login.passwordResetError || "";

export const getLoginResetPasswordSent = (state: AppState) =>
  state.login.resetPasswordSent || false;
